/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};
(function ($) {
  'use strict';

  app.GiftForActionItemView = app.ItemView.extend({
    beforeRun: function () {
      this.template = app.helpers.TemplateHelper.getTemplate('#cart_gift_for_action_item_template');
    },
    render: function () {
      var that = this;
      var element = $(this.template({
        itemUrl: that.model.url,
        itemPhoto140: that.model.img_url,
        itemPhoto400: that.model.img_url_400,
        qty: that.model.reserved_qty,
        country: that.model.country,
        description: that.model.set_name,
        setUrl: '/gift-for-action/' + that.model.set_id + '/',
        name: that.model.name,
        sid: that.model.sid
      }));
      this.setElement(element);
      return this;
    },
  });
})(jQuery);

}.call(window));